(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testi-grid"] && !Shopify.designMode) return;
  try {
    
  const testimonialData = [
  // {
  //   firstname: "Alex",
  //   lastname: "Smith",
  //   role: "Product Manager",
  //   company: "Acme Inc",
  //   testimonial: "This product completely transformed our workflow. The efficiency gains were immediate and substantial.",
  //   country: "Singapore"
  // },
  // {
  //   firstname: "Jamie", 
  //   lastname: "Johnson",
  //   role: "Software Engineer",
  //   company: "TechGlobe",
  //   testimonial: "I was skeptical at first, but after using it for a week, I can't imagine going back to our old system.",
  //   country: "Philippines"
  // },
  // {
  //   firstname: "Jordan",
  //   lastname: "Williams", 
  //   role: "UX Designer",
  //   company: "Innovate Solutions",
  //   testimonial: "The customer support team went above and beyond to ensure we had a smooth implementation.",
  //   country: "Singapore"
  // }
  // {
  //   firstname: "Taylor",
  //   lastname: "Brown",
  //   role: "Marketing Director", 
  //   company: "Nexus Group",
  //   testimonial: "We've seen a 40% increase in productivity since adopting this solution. The ROI is incredible.",
  //   country: "Philippines"
  // },
  // {
  //   firstname: "Casey",
  //   lastname: "Jones",
  //   role: "CEO",
  //   company: "Apex Systems",
  //   testimonial: "The intuitive interface made training our team a breeze. Everyone was up and running in no time.",
  //   country: "Singapore"
  // },
  // {
  //   firstname: "Morgan",
  //   lastname: "Garcia",
  //   role: "Customer Success",
  //   company: "Quantum Enterprises",
  //   testimonial: "This is exactly what we've been looking for. It addresses all our pain points perfectly.",
  //   country: "Philippines"
  // },
  // {
  //   firstname: "Riley",
  //   lastname: "Miller",
  //   role: "Sales Representative",
  //   company: "Stellar Dynamics",
  //   testimonial: "I appreciate how customizable everything is. We were able to tailor it to our specific needs.",
  //   country: "Singapore"
  // },
  // {
  //   firstname: "Quinn",
  //   lastname: "Davis",
  //   role: "Project Manager",
  //   company: "Horizon Technologies",
  //   testimonial: "The analytics features provide insights we never had access to before. Game-changer for our strategy.",
  //   country: "Philippines"
  // },
  // {
  //   firstname: "Avery",
  //   lastname: "Rodriguez",
  //   role: "Data Analyst",
  //   company: "Fusion Corp",
  //   testimonial: "We evaluated several options, and this was by far the most comprehensive solution on the market.",
  //   country: "Singapore"
  // },
  // {
  //   firstname: "Blake",
  //   lastname: "Martinez",
  //   role: "CTO",
  //   company: "Pinnacle Industries",
  //   testimonial: "The automation capabilities have freed up our team to focus on more strategic initiatives.",
  //   country: "Philippines"
  // },
  // {
  //   firstname: "Cameron",
  //   lastname: "Hernandez",
  //   role: "Content Creator",
  //   company: "Elevate Digital",
  //   testimonial: "Implementation was faster and smoother than expected. We were operational within days.",
  //   country: "Singapore"
  // },
  // {
  //   firstname: "Dakota",
  //   lastname: "Lopez",
  //   role: "HR Manager",
  //   company: "Momentum Media",
  //   testimonial: "The mobile functionality allows our team to stay productive even when they're on the go.",
  //   country: "Philippines"
  // },
  // {
  //   firstname: "Drew",
  //   lastname: "Gonzalez",
  //   role: "Financial Analyst",
  //   company: "Catalyst Consulting",
  //   testimonial: "This platform scales beautifully with our growing business. No performance issues whatsoever.",
  //   country: "Singapore"
  // },
  // {
  //   firstname: "Emerson",
  //   lastname: "Wilson",
  //   role: "Operations Manager",
  //   company: "Synergy Labs",
  //   testimonial: "The integration with our existing tools was seamless. Everything works together perfectly.",
  //   country: "Philippines"
  // },
  // {
  //   firstname: "Finley",
  //   lastname: "Anderson",
  //   role: "Business Analyst",
  //   company: "Vertex Software",
  //   testimonial: "Security was our top concern, and this solution exceeded all our compliance requirements.",
  //   country: "Singapore"
  // },
  // {
  //   firstname: "Harper",
  //   lastname: "Thomas",
  //   role: "Art Director",
  //   company: "Pulse Networks",
  //   testimonial: "The collaborative features have improved communication across our entire organization.",
  //   country: "Philippines"
  // },
  // {
  //   firstname: "Hayden",
  //   lastname: "Taylor",
  //   role: "Social Media Manager",
  //   company: "Orbit Communications",
  //   testimonial: "We've reduced errors by 60% since implementing this system. The validation features are excellent.",
  //   country: "Singapore"
  // },
  // {
  //   firstname: "Kennedy",
  //   lastname: "Moore",
  //   role: "IT Specialist",
  //   company: "Spark Innovations",
  //   testimonial: "The reporting capabilities give our executives exactly the insights they need for decision-making.",
  //   country: "Philippines"
  // },
  // {
  //   firstname: "Logan",
  //   lastname: "Jackson",
  //   role: "Research Scientist",
  //   company: "Echo Systems",
  //   testimonial: "Our clients have noticed the improvement in our service delivery since we started using this.",
  //   country: "Singapore"
  // },
  // {
  //   firstname: "Mason",
  //   lastname: "Martin",
  //   role: "Legal Counsel",
  //   company: "Prism Analytics",
  //   testimonial: "The regular updates and new features show a commitment to continuous improvement.",
  //   country: "Philippines"
  // },
  // {
  //   firstname: "Parker",
  //   lastname: "Lee",
  //   role: "Brand Strategist",
  //   company: "Vantage Point",
  //   testimonial: "This solution paid for itself within the first quarter through time savings alone.",
  //   country: "Singapore"
  // },
  // {
  //   firstname: "Peyton",
  //   lastname: "Perez",
  //   role: "Account Executive",
  //   company: "Frontier Tech",
  //   testimonial: "The onboarding experience was exceptional. We felt supported every step of the way.",
  //   country: "Philippines"
  // },
  // {
  //   firstname: "Reagan",
  //   lastname: "Thompson",
  //   role: "Creative Director",
  //   company: "Summit Solutions",
  //   testimonial: "We've been able to take on more clients without adding staff thanks to the efficiency gains.",
  //   country: "Singapore"
  // },
  // {
  //   firstname: "Reese",
  //   lastname: "White",
  //   role: "Systems Administrator",
  //   company: "Beacon Enterprises",
  //   testimonial: "The API is well-documented and flexible, allowing us to build exactly what we needed.",
  //   country: "Philippines"
  // },
  // {
  //   firstname: "Rowan",
  //   lastname: "Harris",
  //   role: "Quality Assurance",
  //   company: "Meridian Group",
  //   testimonial: "This has become an essential part of our daily operations. I can't imagine working without it.",
  //   country: "Singapore"
  // },
  // {
  //   firstname: "Sawyer",
  //   lastname: "Sanchez",
  //   role: "Public Relations",
  //   company: "Nova Industries",
  //   testimonial: "The attention to detail in the design shows a deep understanding of user needs.",
  //   country: "Philippines"
  // },
  // {
  //   firstname: "Sidney",
  //   lastname: "Clark",
  //   role: "Customer Support",
  //   company: "Spectrum Digital",
  //   testimonial: "We've tried similar products before, but none were as comprehensive or user-friendly.",
  //   country: "Singapore"
  // },
  // {
  //   firstname: "Skyler",
  //   lastname: "Ramirez",
  //   role: "Technical Writer",
  //   company: "Zenith Corp",
  //   testimonial: "The accessibility features ensure that our entire team can use the platform effectively.",
  //   country: "Philippines"
  // },
  // {
  //   firstname: "Spencer",
  //   lastname: "Lewis",
  //   role: "Product Designer",
  //   company: "Ascend Technologies",
  //   testimonial: "This solution has helped us maintain compliance while streamlining our processes.",
  //   country: "Singapore"
  // },
  // {
  //   firstname: "Tatum",
  //   lastname: "Robinson",
  //   role: "Web Developer",
  //   company: "Radiant Systems",
  //   testimonial: "The cost savings have been significant, both in terms of time and reduced errors.",
  //   country: "Philippines"
  // },
  // {
  //   firstname: "Tristan",
  //   lastname: "Walker",
  //   role: "Mobile Developer",
  //   company: "Luminary Media",
  //   testimonial: "Our team adoption rate was nearly 100% - a testament to how intuitive the platform is.",
  //   country: "Singapore"
  // },
  // {
  //   firstname: "Tyler",
  //   lastname: "Young",
  //   role: "DevOps Engineer",
  //   company: "Velocity Partners",
  //   testimonial: "The customizable dashboards allow each team member to focus on their key metrics.",
  //   country: "Philippines"
  // },
  // {
  //   firstname: "Wesley",
  //   lastname: "Allen",
  //   role: "Network Administrator",
  //   company: "Nimbus Cloud",
  //   testimonial: "We've eliminated several point solutions by consolidating our work on this platform.",
  //   country: "Singapore"
  // }
];
  function getInitials(firstname, lastname) {
      return (firstname[0] + (lastname[0] || '')).toUpperCase();
    }
    const rowsContainer = document.getElementById('testimonial-rows');
    let currentFilter = 'Global';
    function renderPeople() {
      let filtered = testimonialData;
      if (currentFilter !== 'Global') {
        filtered = testimonialData.filter(p => p.country === currentFilter);
      }
      rowsContainer.innerHTML = '';
      filtered.forEach(person => {
        const circle = document.createElement('div');
        circle.className = 'person';
        circle.title = `${person.firstname} ${person.lastname}`;
        circle.innerHTML = `<span>${getInitials(person.firstname, person.lastname)}</span>`;
        circle.addEventListener('click', () => openPopup(person));
        rowsContainer.appendChild(circle);
      });
    }
    // --- Popup ---
    const popup = document.getElementById('testimonial-popup');
    const closeBtn = document.getElementById('close-popup');
    function openPopup(person) {
      document.getElementById('popup-name').textContent = `${person.firstname} ${person.lastname}`;
      document.getElementById('popup-role').textContent = `${person.role} at ${person.company}`;
      document.getElementById('popup-country').textContent = person.country;
      document.getElementById('popup-testimonial').textContent = person.testimonial;
      popup.classList.add('active');
    }
    function closePopup() {
      popup.classList.remove('active');
    }
    closeBtn.addEventListener('click', closePopup);
    popup.addEventListener('click', e => {
      if (e.target === popup) closePopup();
    });
    // --- Filters ---
    document.querySelectorAll('.filter-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        document.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        currentFilter = btn.dataset.country;
        renderPeople();
      });
    });
    // --- Init ---
    renderPeople();

  } catch(e) { console.error(e); }
})();
})();
